import { Component, OnInit } from '@angular/core';
import {
  FormControl,
  FormGroup,
  FormBuilder,
  Validators,
} from '@angular/forms';
import { NgxSpinnerService } from 'ngx-spinner';
import { AuthenticationService } from 'src/app/services/shared/auth.service';
import { AdminService } from 'src/app/services/admin/admin.service';
import { DeliveryPlatformService } from 'src/app/services/delivery/delivery-platform.service';
import { WebshopService } from 'src/app/services/webshop/webshop.service';
declare var $: any;
@Component({
  selector: 'app-integration-info',
  templateUrl: './integration-info.component.html',
  styleUrls: ['./integration-info.component.scss'],
})
export class IntegrationInfoComponent implements OnInit {
  intFeild: any;
  fromadd: boolean = true;
  intId: any;
  intFormInVaild = false;
  can_upload = 0;
  currentPlatfrom: any;
  posFeild: any;
  modelId: string = 'modalDelete';
  placeholderText: string = 'Search';

  mainIntLoader = true;
  loggedUserRole: any;

  selecteFilterFranchise: any = null;
  selectedFilterShop: any = null;

  user;
  isDataLoaded = false;
  isIntShow = false;
  deliveryPlatforms = [];

  intParameters = <any>[];
  isPlatformTypeSelected = false;
  submittedAddInt = false;
  integratedPlatforms = [];
  loaderSpin = false;
  loaderSpinPos = false;
  submitted = false;
  intSucess = false;
  intEditSucess = false;
  integrationShopSelected = false;
  franchises: any;
  allow_multiple_select: true;
  shops: any = [];
  shopsFilter: any = [];
  qtd: any = [];
  isFilterClicked = false;
  pages: any;
  public visiblePages: any = [];
  currentPage: any;
  selectedIntegration: any;
  selectedIntegrationName: any;
  selectUberDusk: any;
  brands: any = [];

  searchKeyword: any = '';
  filterAvailability: boolean = false;
  filterSearchAvailability: boolean = true;
  noItemsAvailable: string = 'No Integrations available.';
  tableConfig: Array<object> = [
    { id: 1, header: 'Integration ID' },
    {
      id: 2,
      header: 'Integration Name',
      sort: false,
      classType: 'tableHeader',
    },
    { id: 3, header: 'Franchise', classType: 'tableHeader' },
    { id: 4, header: 'Outlet', classType: 'actions no-sort' },
    { id: 5, header: 'Date Added', classType: 'actions no-sort' },
    { id: 6, header: 'Status', classType: 'actions no-sort' },
    { id: 7, type: 'Policy', classType: 'tableHeader_Action actions no-sort' },
  ];
  tableAction: Array<object> = [
    { id: 'edit', type: 'Edit', image: '../../../../../assets/icons/edit.png' },
    {
      id: 'edit',
      type: 'Delete',
      image: '../../../../../assets/icons/delete.png',
    },
  ];

  tableInfo: Array<object> = [
    { id: 1, header: 'id', type: 'Number', classType: 'tableDataFirstCol' },
    { id: 2, header: 'name', type: 'String', classType: 'tableData' },
    {
      id: 2,
      header: 'franchise',
      type: 'Array',
      classType: 'tableData',
      check: function (test) {
        return test.name;
      },
    },
    {
      id: 2,
      header: 'shop',
      type: 'Array',
      classType: 'tableData',
      check: function (test) {
        return test.name;
      },
    },
    { id: 2, header: 'created_at', type: 'String', classType: 'tableData' },
    { id: 3, header: 'status', type: 'Status', classType: 'tableDataStatus' },
    { id: 5, header: 'action' },
  ];
  isDataLoadedUser: boolean = false;
  allAccess = false;
  message: any = '';
  types = [
    { id: 0, name: 'Slave' },
    { id: 1, name: 'Master' },
  ];
  masterTypes: any = [];

  constructor(
    private authService: AuthenticationService,
    private deliveryService: DeliveryPlatformService,
    private spinner: NgxSpinnerService,
    private formBuilder: FormBuilder,
    private adminService: AdminService,
    private webshopService: WebshopService
  ) {}

  ngOnInit(): void {
    this.spinner.show();
    this.callInit()
    $('.selectpicker').selectpicker('refresh');
    $('#spicker_franchise1').selectpicker('refresh');
    $('#spicker_franchise1').selectpicker('val');
  }

  deliveryPlatformForm: FormGroup = new FormGroup({
    name: new FormControl('', [Validators.required]),
    api_url: new FormControl('', [Validators.required]),
    auth_url: new FormControl(''),
    franchise_id: new FormControl('', [Validators.required]),
    franchiseName: new FormControl(''),
    outletName: new FormControl(''),
    outlet_id: new FormControl('', [Validators.required]),
    outlet_code: new FormControl('', [Validators.required]),
    logo: new FormControl('', [Validators.required]),
    api_parameters: this.formBuilder.group({}, [Validators.required]),
    platform_id: new FormControl('', [Validators.required]),
    primary_color: new FormControl('#000000'),
    status: new FormControl('', [Validators.required]),
    can_upload: new FormControl('0', [Validators.required]),
    is_master: new FormControl('', [Validators.required]),
    parent_platform: new FormControl(''),
    webshop_brand_id: new FormControl(''),
    // username:  new FormControl('',),
    // password:  new FormControl('',),
    // uber_dusk:  new FormControl('',),
  });

  get df() {
    return this.deliveryPlatformForm.controls;
  }

  get df_api() {
    return this.deliveryPlatformForm.controls.api_parameters;
  }

  filterForm: FormGroup = new FormGroup({
    franchise: new FormControl(''),
    shop: new FormControl(''),
    franchise_pos: new FormControl(''),
    shop_pos: new FormControl(''),
    shop_auto_aceept: new FormControl(''),
    franchise_auto_aceept: new FormControl(''),
  });

  multiSelect_Form: FormGroup = new FormGroup({
    allow_multi_select: new FormControl(''),
  });

  callInit(){
    this.getCurrentUser();
    this.getBrands();
    this.getDeliveryPlatforms();
    this.getAllFranchise();
    this.geOutlets();
    this.getMasters();
  }

  getCurrentUser() {
    this.loggedUserRole = this.authService.getLoggedUser().user_roles.role_id;
    if (this.loggedUserRole == 4) {
      this.selecteFilterFranchise =
        this.authService.getLoggedUser().shops[0].franchise_id;
      this.selectedFilterShop = this.authService.getLoggedUser().shops[0].id;
      this.getIntegrations();
    } else if (this.loggedUserRole == 3) {
      this.selecteFilterFranchise =
        this.authService.getLoggedUser().franchises[0].id;
      this.getIntegrations();
    } else {
      this.getIntegrations();
    }

    let policies = this.authService.getLoggedUser().policies;

    policies.forEach((element) => {
      if (element.id == 12) {
        this.allAccess = true;
      }
    });
  }

  getBrands() {
    this.webshopService.getBrands().subscribe((res) => {
      console.log(res, 'getBrands');
      this.brands = res.data;
      // this.shopsFilter = res.data;
    });
  }

  getAllFranchise() {
    this.adminService.getAllFranchises().subscribe({
      next: (res) => {
        //console.log(res);
        this.franchises = res.data;
        $('#spicker_franchise_int').selectpicker('refresh');
        $('#spicker_franchise_int').selectpicker('val');
      },
      error: (error) => {
        console.log(error);
      },
    });
  }

  geOutlets() {
    this.adminService.getOutlets().subscribe((res) => {
      //console.log(res, 'outlets')
      this.shops = res.data;
      this.shopsFilter = res.data;
    });
  }

  refreshFilters() {
    if (!this.isFilterClicked) {
      this.isFilterClicked = true;
    } else {
      this.isFilterClicked = false;
    }

    $('#spicker_franchise_int').selectpicker('refresh');
    $('#spicker_franchise_int').selectpicker('val');

    this.loggedUserRole = this.authService.getLoggedUser().user_roles.role_id;
    if (this.loggedUserRole > 2) {
      setTimeout(function () {
        $('#spicker_shop1').removeAttr('disabled');
        $('#spicker_shop1').selectpicker('refresh');
      }, 1);
    }
  }

  async selectFranchise(e) {
    if (this.fromadd) {
      if (e) {
        await this.adminService.getShopsRelatedFranchise(e).subscribe({
          next: (res) => {
            // console.log(res);

            this.shops = res.data;
            this.qtd = [];
            if (this.shops.length == 0) {
              this.integrationShopSelected = false;
            }
            if (!this.fromadd) {
              this.getIntegrations();
            }

            setTimeout(function () {
              $('#spicker_shop_int2').removeAttr('disabled');
              $('#spicker_shop_int2').selectpicker('refresh');
              $('#spicker_shop_int2').selectpicker('val', '');
            }, 1);
          },
          error: (error) => console.log(error + 'Error'),
        });
      }
    }
  }

  async selectFranchiseFilter(e) {
    if (e) {
      this.isDataLoadedUser = true;
      await this.adminService.getShopsRelatedFranchise(e).subscribe({
        next: (res) => {
          this.shopsFilter = res.data;
          this.qtd = [];
          if (this.shopsFilter.length == 0) {
            this.integrationShopSelected = false;
          }

          this.selecteFilterFranchise = e;
          this.selectedFilterShop = null;
          this.getIntegrations();

          setTimeout(function () {
            $('#spicker_shop1').removeAttr('disabled');
            $('#spicker_shop1').selectpicker('refresh');
            $('#spicker_shop1').selectpicker('val', '');
          }, 1);
          this.isDataLoadedUser = false;
        },
        error: (error) => (this.isDataLoadedUser = false),
      });
    }
  }

  selectShop(e) {
    if (this.fromadd) {
      if (e) {
        if (!this.fromadd) {
          this.getIntegrations();
        }
      }
    }
  }

  selectFilterShop(e) {
    if (e) {
      this.integrationShopSelected = true;
      this.selectedFilterShop = e.id;
      this.getIntegrations();
      this.isDataLoadedUser = false;
    }
  }

  onStatusChange(value) {}

  /* From here codes related to integration crud */

  searchItems(event) {
    this.visiblePages = [];
    if (event.target.value == '') {
      this.searchKeyword = '';
    } else {
      this.searchKeyword = event.target.value;
    }

    this.deliveryService
      .getAllIntegrations(
        this.selecteFilterFranchise,
        this.selectedFilterShop,
        this.searchKeyword
      )
      .subscribe((res) => {
        this.integratedPlatforms = res.data.delivery_platforms;
        this.isDataLoadedUser = true;
        this.getPagesCount(res.data.lastPage);
        this.currentPage = res.data.currentPage;
      });
  }

  getIntegrations() {
    this.visiblePages = [];
    this.mainIntLoader = true;
    this.deliveryService
      .getAllIntegrations(
        this.selecteFilterFranchise,
        this.selectedFilterShop,
        this.searchKeyword
      )
      .subscribe((res) => {
        this.integratedPlatforms = res.data.delivery_platforms;
        this.mainIntLoader = false;
        this.isDataLoadedUser = true;
        this.getPagesCount(res.data.lastPage);
        this.currentPage = res.data.currentPage;
        // console.log(res.data, 'integratedPlatforms')
      });
  }

  getPagesCount(pageCount) {
    let pages = [];
    this.visiblePages = [];
    for (let i = 1; i <= pageCount; i++) {
      pages.push(i);
    }
    this.pages = pages;
    this.pages.slice(0, 5).map((i) => {
      this.visiblePages.push(i);
    });
  }

  //pagination

  getMorePages(pageNumber) {
    this.isDataLoaded = false;
    if (pageNumber > 5) {
      this.visiblePages = [];

      this.pages.slice(pageNumber - 5, pageNumber).map((i) => {
        this.visiblePages.push(i);
      });
    } else {
      this.visiblePages = [];
      this.pages.slice(0, 5).map((i) => {
        this.visiblePages.push(i);
      });
    }

    this.deliveryService
      .getMoreIntegrations(
        this.selecteFilterFranchise,
        this.selectedFilterShop,
        pageNumber
      )
      .subscribe((res) => {
        this.integratedPlatforms = res.data.delivery_platforms;
        this.mainIntLoader = false;
        this.isDataLoadedUser = true;
        this.currentPage = res.data.currentPage;
      });
  }

  getDeliveryPlatforms() {
    this.deliveryService.getPlatforms().subscribe((res) => {
      this.deliveryPlatforms = res.data.filter((data) => data.type != 'POS');
      console.log(this.deliveryPlatforms, 'this.deliveryPlatforms');
    });
  }

  updateSwitch(event: any) {
    this.selectUberDusk = event;
    let value = event ? 1 : 0;
    this.deliveryPlatformForm.patchValue({
      uber_dusk: value,
    });
  }

  onTypeChange(index) {
    // console.log(index, this.df_api);
    if (index == -1) {
      this.isPlatformTypeSelected = false;
    } else {
      let test = this.deliveryPlatformForm.controls.api_parameters as FormGroup;

      if (this.currentPlatfrom == index) {
        console.log('Same PLATFORM');
      } else if (this.intFeild) {
        for (let x = 0; x < this.intFeild.length; x++) {
          test.removeControl(this.intFeild[x]);
        }
      }

      this.currentPlatfrom = index;

      this.isPlatformTypeSelected = true;

      this.intParameters = this.deliveryPlatforms.filter(
        (data) => data.id == index
      );

      this.intFeild = this.intParameters[0].parameters;

      let api_parameters = this.deliveryPlatformForm.get(
        'api_parameters'
      ) as FormGroup;

      if (!api_parameters) {
        this.deliveryPlatformForm.addControl(
          'api_parameters',
          this.formBuilder.group({})
        );
        api_parameters = this.deliveryPlatformForm.get(
          'api_parameters'
        ) as FormGroup;
      }

      this.intParameters[0].parameters.forEach((param) => {
        if (!api_parameters.get(param)) {
          api_parameters.addControl(
            param,
            new FormControl('', Validators.required)
          );
        }
      });

      console.log(
        this.deliveryPlatforms[this.currentPlatfrom]?.name,
        this.intParameters[0]?.parameter_values?.version,
        this.intParameters[0]
      );

      if (this.intParameters[0]?.name === 'DELIVEROO') {
        console.log(this.intParameters[0]?.parameter_values?.name);

        const apiParamsPatch: any = {};
        this.intParameters[0].parameters.forEach((param) => {
          if (this.intParameters[0]?.parameter_values?.[param] !== undefined) {
            apiParamsPatch[param] =
              this.intParameters[0]?.parameter_values?.[param];
          }
        });

        api_parameters.patchValue(apiParamsPatch);
        Object.keys(apiParamsPatch).forEach((param) => {
          api_parameters.get(param)?.disable();
        });
        this.deliveryPlatformForm.patchValue({
          api_url: this.intParameters[0]?.parameter_values?.api_url,
          auth_url: this.intParameters[0]?.parameter_values?.auth_url,
        });
        if (this.intParameters[0]?.parameter_values?.api_url ) {
          this.deliveryPlatformForm.get('api_url')?.disable();
        } 
        if (this.intParameters[0]?.parameter_values?.auth_url) {
          this.deliveryPlatformForm.get('auth_url')?.disable();
        }
      } else {
        Object.keys(api_parameters.controls).forEach((param) => {
          api_parameters.get(param)?.enable();
          api_parameters.get(param)?.setValue('');
        });

        this.deliveryPlatformForm.get('api_url')?.enable();
        this.deliveryPlatformForm.get('api_url')?.setValue('');
        this.deliveryPlatformForm.get('auth_url')?.enable();
        this.deliveryPlatformForm.get('auth_url')?.setValue('');
      }
    }
  }

  selectType(type) {
    if (type == 0) {
      this.setValidators();
    } else {
      this.removeValidators();
    }
  }

  getMasters() {
    this.deliveryService.getMasters().subscribe((res) => {
      console.log(res.data);
      this.masterTypes = res.data;
    });
  }
  setValidators() {
    this.submitted = false;
    this.deliveryPlatformForm.controls[`parent_platform`].setValidators(
      Validators.required
    );
  }

  removeValidators() {
    this.deliveryPlatformForm.controls[`parent_platform`].clearValidators();
    this.deliveryPlatformForm.controls[
      `parent_platform`
    ].updateValueAndValidity();
  }
  addIntClick() {
    this.intFormInVaild = false;
    this.message = '';
    this.intEditSucess = false;
    this.intSucess = false;
    this.fromadd = true;
    this.isPlatformTypeSelected = false;
    this.deliveryPlatformForm.patchValue({
      platform_id: '',
      status: '',
      can_upload: '0',
    });

    $('#spicker_franchise_int2').removeAttr('disabled');
    $('#spicker_franchise_int2').selectpicker('refresh');
    $('#spicker_franchise_int2').selectpicker('val', '');

    $('#spicker_shop_int2').selectpicker('refresh');
    $('#spicker_shop_int2').selectpicker('val', '');

    // console.log(this.deliveryPlatformForm.value);
  }

  addIntegration() {
    this.message = '';
    this.submittedAddInt = true;
    this.intFormInVaild = false;
    console.log(this.deliveryPlatformForm, this.deliveryPlatformForm.getRawValue(), 'After Add');

    if (this.deliveryPlatformForm.invalid) {
      // console.log(this.deliveryPlatformForm.invalid);
      this.intFormInVaild = true;
      this.deliveryPlatformForm.setErrors({
        invalidAdd: true,
      });
    } else {
      this.loaderSpin = true;
      this.deliveryService
        .addPlatform(this.deliveryPlatformForm.getRawValue())
        .subscribe({
          next: (res) => {
            this.loaderSpin = false;
            this.intSucess = true;
            this.submittedAddInt = false;
            this.selecteFilterFranchise = null;
            this.selectedFilterShop = null;
            this.deliveryPlatformForm.reset();
            this.getIntegrations();
            this.message = 'Integration Added Successfully!';
            this.removeValidators();
          },
          error: (error) => {
            console.log(error + 'Error');
            this.message = 'Failed to add integration! ' + error + '!';
            this.submittedAddInt = false;
            this.intSucess = false;
            this.loaderSpin = false;
          },
        });
    }
  }

  onEditClicked(data) {
    this.intFormInVaild = false;
    this.intEditSucess = false;
    this.intSucess = false;
    this.deliveryPlatformForm.reset();
    this.df_api.reset();
    this.fromadd = false;
    this.isPlatformTypeSelected = true;

    if (data.platform_id) {
      this.onTypeChange(data.platform_id);
    }
    // console.log(data);
    this.intId = data.id;

    this.deliveryPlatformForm.patchValue(data);

    this.selectUberDusk = data.uber_dusk == 1 ? true : false;

    console.log(this.deliveryPlatformForm.value);
    this.deliveryPlatformForm.patchValue({
      can_upload: data.can_upload.toString(),
    });

    let selectedFranchise = [];
    let tmpselectedFranchise = [];

    let selectedShops = [];
    let tmpselectedShops = [];

    this.deliveryPlatformForm.patchValue({
      franchiseName: data.franchise.name,
    });

    this.deliveryPlatformForm.patchValue({
      outletName: data.shop.name,
    });

    // this.deliveryPlatformForm.patchValue({
    //   parent_platform: data.shop.parent_platform
    // });

    //set selected franchise
    tmpselectedFranchise.push(data.franchise.id);

    this.franchises.forEach((value, index) => {
      if (tmpselectedFranchise.includes(value.id)) {
        selectedFranchise.push(index + ': ' + value.id);
      }
    });

    this.deliveryPlatformForm.patchValue({
      franchise: tmpselectedFranchise,
    });

    //set selected shop
    tmpselectedShops.push(data.outlet_id);

    this.shops.forEach((value, index) => {
      if (tmpselectedShops.includes(value.id)) {
        selectedShops.push(index + ': ' + value.id);
      }
    });

    this.deliveryPlatformForm.patchValue({
      outlet_id: data.outlet_id,
    });
    $('#spicker_franchise_int2').selectpicker('refresh');
    $('#spicker_franchise_int2').selectpicker('val', selectedFranchise);
    $('#spicker_shop_int2').selectpicker('refresh');
    $('#spicker_shop_int2').selectpicker('val', selectedShops);
    $('#integrationModal').modal('show');
  }

  //delete Integrations Model
  open_deleteItemModal(data) {
    // console.log(data, 'selected')

    this.selectedIntegration = data;
    this.selectedIntegrationName = data.name;
    $('#modalDelete').modal('show');
  }

  //delete Integrations API
  deleteOutlet() {
    this.loaderSpin = true;
    this.deliveryService
      .deleteIntegration(this.selectedIntegration.id)
      .subscribe({
        next: (res) => {
          this.getIntegrations();
          this.loaderSpin = false;
          $('#modalDelete').modal('hide');
        },
        error: (error) => {
          console.log(error);
          this.loaderSpin = false;
        },
      });
  }

  editIntegration() {
    this.fromadd = false;
    this.submittedAddInt = true;
    this.intFormInVaild = false;
    console.log(
      this.deliveryPlatformForm.getRawValue(),
      this.deliveryPlatformForm.value,
      'After Add',
      this.deliveryPlatformForm
    );

    if (this.deliveryPlatformForm.invalid) {
      console.log(this.deliveryPlatformForm.invalid);
      this.intFormInVaild = true;
      this.deliveryPlatformForm.setErrors({
        invalidAdd: true,
      });
    } else {
      this.loaderSpin = true;
      // console.log(this.deliveryPlatformForm.value);
      this.deliveryService
        .updatePlatform(this.intId, this.deliveryPlatformForm.getRawValue())
        .subscribe({
          next: (res) => {
            this.loaderSpin = false;
            this.intSucess = true;
            this.submittedAddInt = false;
            // this.fromadd = true;
            //this.deliveryPlatformForm.reset();
            this.message = 'Integration Update Successfully!';
            //$('#integrationModal').modal('hide');
            this.getIntegrations();
            this.removeValidators();
          },
          error: (error) => {
            console.log(error + 'Error');
            this.message = 'Failed to add integration! ' + error + '!';
            this.submittedAddInt = false;
            this.intSucess = false;
            this.loaderSpin = false;
          },
        });
    }
  }

  onCancelModal() {
    //this.geOutlets();
    this.isPlatformTypeSelected = false;
    this.message = '';
    this.fromadd = false;
    this.intSucess = false;
    this.intEditSucess = false;
    this.submittedAddInt = false;
    this.deliveryPlatformForm.reset();
    this.deliveryPlatformForm.enable()
    //this.deliveryPlatformForm.controls.api_parameters.reset();
    $('.modal-backdrop').remove();
    $('#integrationModal').modal('hide');
  }

  modalClose() {
    this.intEditSucess = false;
  }

  modalCloseSucess() {
    this.intSucess = false;
  }
}
